import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export default ({ label, style, margin, checked, disabled, classes, onChange, className, disableRipple }) => (
  <FormControlLabel
    label={label}
    style={style}
    classes={classes}
    disabled={disabled}
    className={className}
    margin={margin || 'none'}
    control={<Checkbox color="primary" checked={checked} onChange={onChange} disableRipple={disableRipple} />}
  />
);
